import { Object as FabricObject } from 'fabric/fabric-impl';
import { SportType } from 'modules/core/domain/enums/sport-type';
import { MediaKind } from 'modules/manager/domain/media-kind';
import { MatchLayoutSettings } from 'modules/manager/domain/match-layout';
import { PlayerRankingSettings } from 'modules/manager/domain/player-stats';
import { TemplateType } from 'modules/manager/domain/template-type';

/** Marker that tells our file apart from any other JSON. Never change it. */
export const TEMPLATE_FILE_FORMAT = 'imgame.media-manager-templates';

/**
 * Bump on an incompatible change of the entry shape. The parser rejects files
 * from a newer version instead of guessing, so already downloaded files keep
 * working and a stale tab says «обновите страницу».
 */
export const TEMPLATE_FILE_VERSION = 1;

export const TEMPLATE_FILE_SUFFIX = '.imgame-template.json';

/** Fabric version stamped on templates created by the editor today. */
export const DEFAULT_TEMPLATE_OBJECTS_VERSION = '5.3.0';

/**
 * One template in a file. No `id`, `tournamentId`, `order` or dates: they belong
 * to the source stand and organization and are assigned anew on import.
 */
export interface TemplateFileEntry {
  name: string;
  version: string;
  width: number;
  height: number;
  sportType: SportType | null;
  templateType: TemplateType;
  mediaKind: MediaKind;
  /**
   * The template was the group's default for its kind. A file without the field
   * (exported before IMGM-1614) reads as `false`. Import applies it only where the
   * target group has no default of that kind yet.
   */
  isDefaultForKind: boolean;
  templateSubtypes: string[];
  matchLayout: MatchLayoutSettings;
  playerRanking: PlayerRankingSettings;
  objects: FabricObject[];
}

export interface TemplateFile {
  format: typeof TEMPLATE_FILE_FORMAT;
  formatVersion: number;
  exportedAt: string;
  source: { origin: string };
  templates: TemplateFileEntry[];
}
